<!-- Author Kalpesh created date:- 25/01/2022 -->
<div class="topdiv">
    <label i18n="@@spmsUserReg" class="textColour">Target Library Objects</label>
    <span class="example-spacer"></span>

        <div class="row" style="margin-top: 30px;">
          <div class="col-12">
            <div class="seperateDiv">
              <ag-grid-angular style="height: 260px;" id="Grid" class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnDefsForObjects"  [animateRows]="true"  [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowMultiSelectWithClick]="true"

                [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45" [enableRangeSelection]="true" [debug]="true"
                (gridReady)="onGridReadyForObjects($event)" (rowSelected)="onRowSelected($event)"  [hidden]="!true">
              </ag-grid-angular>
            </div>
          </div>

        </div>
        <div class="row mb-1 topRowMargins" style= "position:sticky;left:0;bottom:0;width:100%;background-color: #fff;">
            <div class="col-lg text-center">
              <div style="text-align: end; margin-top: 10px;">

                  <button i18n="@@TMRunButton" title="Re-Extract" type="button" (click)="reextract()" class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                  style="padding: .3rem 1.6rem;font-size: .85rem;" [style.background-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean">Re-Extract</button>


                  <button i18n="@@TMRunButton" title="Cancel" type="button" (click)="cancel()" class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                  style="padding: .3rem 1.6rem;font-size: .85rem;" [style.border-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean" >Cancel</button>

              </div>
            </div>
          </div>

</div>

